import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import KlaroPlugin from "./plugins/klaro";
import { createHead } from "@unhead/vue/client";

import "./style.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/css/owl.carousel.min.css";
import "./assets/css/owl.theme.default.min.css";
import "./assets/css/aos.css";
import "./assets/css/magnific-popup.css";

const app = createApp(App);
const head = createHead();

app.use(head);
app.use(router);
app.use(i18n);
app.use(KlaroPlugin);

app.mount("#app");

// Sincronitzar idioma
router.beforeEach((to, from, next) => {
  const lang = to.path.startsWith("/en") ? "en" : "es";
  i18n.global.locale.value = lang;
  next();
});

// Import and configure JS libraries after Vue has mounted
// We need to do this in a way that doesn't interfere with Vue's lifecycle
window.addEventListener("load", () => {
  // Import external scripts from CDN
  const loadScript = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  };

  // Load FontAwesome
  loadScript(
    "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/js/all.min.js"
  )
    .then(() => {})
    .catch((error) => console.error("Error loading FontAwesome:", error));

  // Load jQuery and Bootstrap
  loadScript("https://code.jquery.com/jquery-3.7.1.min.js")
    .then(() => {
      return loadScript(
        "https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js"
      );
    })
    .then(() => {
      return loadScript("/assets/js/owl.carousel.js");
    })
    .then(() => {
      return loadScript(
        "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.min.js"
      );
    })
    .then(() => {
      // Load Seaquest theme scripts
      return Promise.all([
        loadScript("/assets/js/aos.js"),
        loadScript("/assets/js/whatsapp-button.js"),
        loadScript("/assets/js/preloader.js"),
        loadScript("/assets/js/search.js"),
        loadScript("/assets/js/carousel.js"),
        loadScript("/assets/js/counter.js"),
        loadScript("/assets/js/animation.js"),
      ]);
    })
    .then(() => {
      // Initialize AOS
      if (window.AOS) {
        window.AOS.init();
      }
    })
    .catch((error) => console.error("Error loading scripts:", error));
});
